import { settingsRoutes } from './settingsRoutes';

const base = settingsRoutes.application;

export const applicationSettingsRoutes = {
  base,
  featureToggling: `${base}/feature-toggling`,
  functionalityAdjustment: `${base}/functionality-adjustment`,
  personalization: `${base}/personalization`,
  broadcastTags: `${base}/broadcast-tags`,
} as const;
